import React, { Component } from "react";
import moment from "moment";
import { ModalPrint } from "../../gen/polizas/ModalPrint";
import Alerts from "../../util/Alerts";

export class Contratante extends Component {
    constructor(props) {
        super(...arguments);
        this.alert = React.createRef();
        this.state = {
            open: false,
            pdf: false,
            aseg: false,
        };
    }

    closeModal = val => {
        this.setState({ open: val, pdf: false, aseg: false });
    };

    render() {
        let { poliza, item, user, vida } = this.props;

        return (
            <div className="col-lg-3 bg-primary pd-lateral pt-2 pt-md-5">
                <Alerts ref={this.alert} />
                <table className="m-auto text-left fs12 line-height-normal">
                    <tbody>
                        <tr>
                            <td className="font-weight-bolder text-primary">Contratante:</td>
                        </tr>
                        <tr>
                            <td>{poliza.nmCliente}</td>
                        </tr>
                        <tr>
                            <td className="font-weight-bolder text-primary">Aseguradora:</td>
                        </tr>
                        <tr>
                            <td>{poliza.nmAseguradora}</td>
                        </tr>
                        <tr>
                            <td className="font-weight-bolder text-primary">Ramo:</td>
                        </tr>
                        <tr>
                            <td>{poliza.nmRamo}</td>
                        </tr>
                        <tr>
                            <td className="font-weight-bolder text-primary">Póliza:</td>
                        </tr>
                        <tr>
                            <td>{poliza.poliza}</td>
                        </tr>
                        <tr>
                            <td className="font-weight-bolder text-primary">Plan:</td>
                        </tr>
                        <tr>
                            <td>{item.dscRubro}</td>
                        </tr>
                        <tr>
                            <td className="font-weight-bolder text-primary">Fc Desde:</td>
                        </tr>
                        <tr>
                            <td>
                                {poliza.fcDesde
                                    ? moment(poliza.fcDesde).locale("moment/locale/es").local().format("DD/MMM/YYYY")
                                    : null}
                            </td>
                        </tr>
                        <tr>
                            <td className="font-weight-bolder text-primary">Fc Hasta:</td>
                        </tr>
                        <tr>
                            <td>
                                {poliza.fcHasta
                                    ? moment(poliza.fcHasta).locale("moment/locale/es").local().format("DD/MMM/YYYY")
                                    : null}
                            </td>
                        </tr>
                        {/*<tr>*/}
                        {/*    <p className={"font-weight-bolder text-primary"}>Reportes</p>*/}
                        {/*</tr>*/}
                        <br />
                    </tbody>
                </table>
                <ModalPrint
                    cdCompania={poliza.cdCompania}
                    cdRamoCotizacion={item.cdRamoCotizacion}
                    cdCotizacion={vida ? poliza.cdCotizacion : item.cdCotizacion}
                    alert={this.alert.current}
                    setOpen={this.closeModal}
                    open={this.state.open}
                    pdf={this.state.pdf}
                    vam={vida}
                    aseg={this.state.aseg}
                    poliza={poliza.poliza}
                />
            </div>
        );
    }
}
